import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchEvents,
  fetchEventById,
  createEvent,
  updateEvent,
  deleteEvent,
  assignStaff,
  assignEquipment,
  addSchedule,
  addExpense,
  updateWorkflow,
  updateInvoiceInfo,
  fetchEventStats,
  clearErrorState,
  clearSuccessState,
  updateFilters,
  clearSelectedEvent,
} from "../../../app/slice/eventSlice";

const useEvent = () => {
  const dispatch = useDispatch();
  const { events, selectedEvent, stats, loading, error, success, filters } =
    useSelector((state) => state.events);

  const getEvents = useCallback((f) => dispatch(fetchEvents(f)), [dispatch]);
  const getEventById = useCallback(
    (id) => dispatch(fetchEventById(id)),
    [dispatch],
  );

  const createNewEvent = useCallback(
    (data, createdBy) => dispatch(createEvent({ data, createdBy })).unwrap(),
    [dispatch],
  );

  const updateExistingEvent = useCallback(
    (id, data) => dispatch(updateEvent({ id, data })).unwrap(),
    [dispatch],
  );

  const deleteExistingEvent = useCallback(
    (id) => dispatch(deleteEvent(id)).unwrap(),
    [dispatch],
  );

  const assignStaffToEvent = useCallback(
    (eventId, staffMember) =>
      dispatch(assignStaff({ eventId, staffMember })).unwrap(),
    [dispatch],
  );

  const assignEquipmentToEvent = useCallback(
    (eventId, equipmentItem) =>
      dispatch(assignEquipment({ eventId, equipmentItem })).unwrap(),
    [dispatch],
  );

  const addScheduleDay = useCallback(
    (eventId, scheduleDay) =>
      dispatch(addSchedule({ eventId, scheduleDay })).unwrap(),
    [dispatch],
  );

  const addEventExpense = useCallback(
    (eventId, expense) => dispatch(addExpense({ eventId, expense })).unwrap(),
    [dispatch],
  );

  const updateEventWorkflow = useCallback(
    (eventId, workflowUpdates) =>
      dispatch(updateWorkflow({ eventId, workflowUpdates })).unwrap(),
    [dispatch],
  );

  const updateEventInvoice = useCallback(
    (eventId, invoiceUpdates) =>
      dispatch(updateInvoiceInfo({ eventId, invoiceUpdates })).unwrap(),
    [dispatch],
  );

  const getEventStats = useCallback(
    () => dispatch(fetchEventStats()),
    [dispatch],
  );

  const clearErrorStateFn = useCallback(
    () => dispatch(clearErrorState()),
    [dispatch],
  );
  const clearSuccessStateFn = useCallback(
    () => dispatch(clearSuccessState()),
    [dispatch],
  );
  const updateFiltersFn = useCallback(
    (f) => dispatch(updateFilters(f)),
    [dispatch],
  );
  const clearSelected = useCallback(
    () => dispatch(clearSelectedEvent()),
    [dispatch],
  );

  return {
    events,
    selectedEvent,
    stats,
    loading,
    error,
    success,
    filters,
    getEvents,
    getEventById,
    createNewEvent,
    updateExistingEvent,
    deleteExistingEvent,
    assignStaffToEvent,
    assignEquipmentToEvent,
    addScheduleDay,
    addEventExpense,
    updateEventWorkflow,
    updateEventInvoice,
    getEventStats,
    clearErrorState: clearErrorStateFn,
    clearSuccessState: clearSuccessStateFn,
    updateFilters: updateFiltersFn,
    clearSelectedEvent: clearSelected,
  };
};

export default useEvent;
